import api from "./api";
//退出登陆
export const $sp_signOut = (params) => api.post('/hengxin/erp/api/client/biz/mine/user/signOut', params);
//获取用户信息
export const $sg_getUserInfo = (params) => api.get("/hengxin/erp/api/client/biz/mine/user/getUserInfo", params);
//修改用户信息
export const $sp_updateUserInfo = (params) => api.postNoTips("/hengxin/erp/api/client/biz/mine/user/update", params);
//解绑代理商
export const $sp_unBindAgentApply = params => api.getNoTips("/hengxin/erp/api/client/biz/mine/user/unBindAgentApply", params);
//撤销解绑代理商
export const $sp_undoBindAgentApply = params => api.getNoTips("/hengxin/erp/api/client/biz/mine/user/undoBindAgentApply", params);
//代理商客户消费统计
export const $sp_getAgentClientStatList = (params) => api.postNoTips('/hengxin/erp/api/client/biz/my/pageAgentClientConsStatListVO', params);
//代理商客户列表
export const $sp_getAgentClientList = (params) => api.postNoTips('/hengxin/erp/api/client/biz/mine/user/getAgentClientList', params);

//代理商解绑客户
export const $sg_agentUnBindClient = (params) => api.getNoTips('/hengxin/erp/api/client/biz/mine/user/unBind', params);

//代理商编辑客户
export const $sp_agentUpdateClientInfo = (params) => api.post('/hengxin/erp/api/client/biz/mine/user/updateClientInfo', params);

//代理商客户收益记录
export const $sp_getAgentClientRebateInfo = (params) => api.postNoTips('/hengxin/erp/api/client/biz/mine/user/getAgentClientRebateInfo', params);

//代理商解绑审核列表
export const $sp_getUnBindAgentList = (params) => api.postNoTips('/hengxin/erp/api/client/biz/mine/user/unBindAgentList', params);

//代理商解绑审核 - 同意
export const $sg_applyUnBind = (params) => api.getNoTips('/hengxin/erp/api/client/biz/mine/user/applyUnBind', params);
//获取所属业务员电话
export const $sp_prePhone = params => api.getNoTips("/hengxin/erp/api/client/biz/mine/user/getClientSalemansTel", params);
//修改用户密码
export const $sp_updatePassword = (params) => api.postNoTips("/hengxin/erp/api/client/biz/mine/user/updatePassword", params);
//修改用户支付密码
export const $sp_updatePayPwd = (params) => api.postNoTips("/hengxin/erp/api/client/biz/my/secure/updatePayPwd", params);
//校验用户支付密码
export const $sp_verifyPhonePwd = (params) => api.postNoTips("/hengxin/erp/api/client/biz/my/secure/verifyPhonePwd", params);
//获取用户收货地址
export const $sg_getUserAddress = params => api.postNoTips("/hengxin/erp/api/client/biz/order/delivery/address2", params);
//新增用户收货地址
export const $sg_addUserAddress = params => api.postNoTips("/hengxin/erp/api/client/biz/my/address/save", params);
//新增门店收货地址
export const $sg_addMicroWarehouseAddress = params => api.postNoTips("/hengxin/erp/api/client/biz/my/address/microWarehouse/save", params);
//删除用户收货地址
export const $sg_delUserAddress = params => api.getNoTips("/hengxin/erp/api/client/biz/my/address/del", params);

// 门店地址
// 地址列表
export const $sg_addressList = params => api.getNoTips("/hengxin/erp/api/client/biz/my/address/list", params);

//修改用户收货地址
export const $sp_updateReceiveInfo = params => api.post("/hengxin/erp/api/client/biz/mine/user/updateReceiveInfo", params);

//余额查询
export const $sg_balance = (params) => api.get('/hengxin/erp/api/client/biz/mine/user/balance', params);
//查询余额支出记录
export const $sp_getBalanceRecord = (params) => api.postNoTips('/hengxin/erp/api/client/biz/mine/user/balance/record', params);
//提现信息查询
export const $sg_getClientPayoutInfo = (params) => api.getNoTips('/hengxin/erp/api/client/biz/mine/user/getClientPayoutInfo', params);
//发送绑定银行卡验证码
export const $sg_sendBindSms = (params) => api.get('/hengxin/erp/api/client/biz/mine/user/sendBindSms', params);
//绑定银行卡
export const $sp_bindWithdrawCard = (params) => api.postNoTips('/hengxin/erp/api/client/biz/mine/user/bindCard', params);
//发起提现申请
export const $sp_sendWithdrawApply = (params) => api.postNoTips('/hengxin/erp/api/client/biz/mine/user/payout', params);
//余额记录详情
export const $sg_queryBalanceOrderInfo = (params) => api.postNoTips('/hengxin/erp/api/client/biz/mine/user/balanceOrderInfo', params);
// 充值/归还额度
export const $sp_payOrderV2 = (params) => api.postNoTips('/hengxin/erp/api/client/biz/mine/user/recharge/v2', params);//v1.2
// 支付状态查询
export const $sp_queryPayStatus = (params) => api.postNoTips('/hengxin/erp/api/client/biz/mine/user/recharge/queryOrderStatus', params);//v1.2

//我的积分 总额
export const $sg_integralTotal = (params) => api.get('/hengxin/erp/api/client/biz/mine/points/total', params);
//我的积分 列表
export const $sg_integral = (params) => api.get('/hengxin/erp/api/client/biz/mine/points/page', params);
//授信额度查询
export const $sg_queryLimitInfo = (params) => api.get('/hengxin/erp/api/client/biz/mine/limit/info', params);
//授信额度记录
export const $sp_queryLimitRecord = (params) => api.postNoTips('/hengxin/erp/api/client/biz/mine/limit/list', params);
//我的优惠劵 列表/历史记录/已过期
export const $sg_coupon = (params) => api.get('/hengxin/erp/api/client/biz/mine/coupon/getCouponList', params);

//获取待开票订单
export const $sg_queryInvoiceOrderList = params => api.getNoTips("/hengxin/erp/api/client/biz/my/invoice/orderList", params);
//获取发票记录
export const $sg_queryInvoiceRecordList = params => api.getNoTips("/hengxin/erp/api/client/biz/my/invoice/invoiceList", params);
//获取发票记录详情
export const $sg_queryInvoiceRecordInfo = params => api.getNoTips("/hengxin/erp/api/client/biz/my/invoice/record", params);
//开票
export const $sp_createInvoice = (params) => api.postNoTips('/hengxin/erp/api/client/biz/my/invoice/create', params);

//申请渠道商
export const $sp_addDistributor = params => api.postNoTips("/hengxin/erp/api/client/biz/mine/user/addDistributorInfo", params);
//渠道商信息
export const $sp_getDistributorInfo = params => api.getNoTips("/hengxin/erp/api/client/biz/mine/user/getDistributorInfo", params);

//申请代理商
export const $sp_addAgentInfo = params => api.postNoTips("/hengxin/erp/api/client/biz/mine/user/addAgentInfo", params);

// 消息中心列表
export const $sp_queryMsgList = params => api.postNoTips("/hengxin/erp/api/client/biz/my/message/list", params);

// 意见反馈-提交
export const $sp_submitFeedBack = params => api.post("/hengxin/erp/api/client/biz/my/setting/submitFeedBack", params);
// 意见反馈类型
export const $sg_queryFeedBackTypes = params => api.get("/hengxin/erp/api/client/biz/my/setting/FeedBackList", params);
// 意见反馈记录
export const $sp_queryFeedbackRecord = params => api.postNoTips("/hengxin/erp/api/client/biz/my/setting/feedback/record", params);

//获取邀请券
export const $sg_getInviteCoupon = params => api.get('/hengxin/erp/api/client/biz/my/invitedCouponList', params);

//获取邀请码
export const $sg_createInviteCode = params => api.get('/hengxin/erp/api/client/biz/mine/user/my/getInviteCode', params);

//渠道商信息
export const $sp_getInvoiceRecord = params => api.getNoTips("/hengxin/erp/api/client/biz/my/invoice/record", params);
